import { render, staticRenderFns } from "./produtos.vue?vue&type=template&id=36a8e298&scoped=true"
import script from "./produtos.vue?vue&type=script&lang=js"
export * from "./produtos.vue?vue&type=script&lang=js"
import style0 from "./produtos.vue?vue&type=style&index=0&id=36a8e298&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a8e298",
  null
  
)

export default component.exports